export const SYNC_MEZZO_TIME = '@@mezzoTime/mezzoTimeSync'

export const SET_MEZZO_TIME = '@@mezzoTime/mezzoTimeSet'

export const RESET_MEZZO_TIME = '@@mezzoTime/reset'
